var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConciergeBellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.438 2.4a.935.935 0 00-.938.938c0 .52.418.937.938.937h.624v1.3a8.749 8.749 0 00-7.812 8.7h17.5a8.749 8.749 0 00-7.813-8.7v-1.3h.626c.519 0 .937-.418.937-.937a.935.935 0 00-.938-.938H8.438zm-7.5 13.125a.935.935 0 00-.938.937c0 .52.418.938.938.938h18.125c.519 0 .937-.418.937-.938a.935.935 0 00-.938-.937H.938z",
    fill: "#093545"
  })));
}

export default SvgConciergeBellIcon;